// @view/Prompt.tsx
import React, { useState } from "react";
import * as styles from "@styles/Prompt.css";
import { Send } from "lucide-react";

import * as IO from "@ps-bridge/interop/io";
import { ok } from "@ps-bridge/ok";
import type { DocumentPromptViewProps } from "@ps-bridge/contracts/documentPrompt";
import { renderMarkdownHtml } from "@utils/markdown";
import { useDocumentAssistantDictation } from "@hooks/useDocumentAssistantDictation";
import DocumentAssistantDictationControl from "@view/document/DocumentAssistantDictationControl";

const PromptComponent: React.FC<DocumentPromptViewProps> = ({
  probingQuestion,
  onSubmit,
}) => {
  const [userInput, setUserInput] = useState("");
  const dictation = useDocumentAssistantDictation({
    fieldId: "prompt",
    value: userInput,
    setValue: (value) => {
      setUserInput(value);
      return ok;
    },
  });

  return (
    <div className={styles.container}>
      <p className={styles.header}>Probing Questions</p>
      <div className={styles.probingQuestionContainer}>
        <div
          data-testid="prompt-probing-question-markdown"
          className={styles.probingQuestion}
          dangerouslySetInnerHTML={{ __html: renderMarkdownHtml(probingQuestion) }}
        />
      </div>

      <div className={styles.inputRow}>
        <textarea
          ref={dictation.inputBindings.ref}
          data-testid="prompt-answer-input"
          className={styles.input}
          rows={5}
          value={userInput}
          onChange={(event) => setUserInput(event.target.value)}
          onClick={dictation.inputBindings.onClick}
          onFocus={dictation.inputBindings.onFocus}
          onSelect={dictation.inputBindings.onSelect}
          placeholder="Type your answer here..."
        />
        <DocumentAssistantDictationControl
          {...dictation.controlState}
          buttonClassName={styles.button2}
          iconClassName={styles.buttonIcon}
        />
        <button
          data-testid="prompt-submit"
          className={styles.button2}
          onClick={() => {
            IO.run(onSubmit(userInput));
            setUserInput("");
          }}
        >
          <Send size={16} className={styles.buttonIcon} />
        </button>
      </div>
    </div>
  );
};

export default PromptComponent;
